import * as React from 'react';
import Slider from 'react-slick';
import { styled } from '../styles/stitches.config';
import { navigate, graphql, useStaticQuery, Link } from 'gatsby';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ingredientLibrary from '../images/ingredientlibrary.png';
import { StaticImage } from 'gatsby-plugin-image';
import BackgroundImage from 'gatsby-background-image';
import { useEffect, useState } from 'react';

export const InstagramFeed = () => {
    const [images, setImages] = useState([]);
    useEffect(() => {
        fetch('https://v1.nocodeapi.com/mrkuok/google_sheets/PWjtIPEhWKqmOHPT?tabId=Sheet1')
            .then(res => res.json())
            .then(res => {
                fetch('https://graph.instagram.com/me/media?fields=id,caption,permalink,media_type,media_url,thumbnail_url&access_token=' + res.data[0].accessToken + '&limit=8')
                    .then(res => res.json())
                    .then(res => {
                        setImages(res.data);
                        console.log(res.data);
                    });
            })

    }, []);

    const InstagramContainer = styled('div', {
        marginTop: '48px',
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gridTemplateRows: '1fr 1fr',
        gap: '20px',
        '@bp1': {
            gridTemplateColumns: '1fr 1fr',
        },
        '& img': {
            width: '100%',
        },
        '& div': {
            aspectRatio: 1,
            overflow: 'hidden',
            '&:hover': {
                opacity: 0.9,
            }
        },
    });

    const InstaFeed = styled('div', {
        padding: '80px 120px',
        textAlign: 'center',
        '@bp1': {
            padding: '80px 20px',
        },
        '@bp2': {
            padding: '80px 40px',
        },
        '@bp3': {
            padding: '80px 120px',
        },
        '& h2': {
            fontFamily: '$default',
            fontSize: '48px',
            lineHeight: '1.2',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
        '& h3': {
            fontSize: '16px',
            marginBottom: '12px',
            fontFamily: '$lato',
            textTransform: 'uppercase',
            letterSpacing: '.1em',
        },
    });

    return (
        <InstaFeed>
            <a href="https://www.instagram.com/bedaskin" target="_blank" rel="noreferrer"><h3>Follow us on Instagram</h3>
                <h2>@bedaskin</h2></a>
            <InstagramContainer>
                {images ? images.map(image => (
                    <div key={image.permalink}>
                        <a href={image.permalink} target="_blank" rel="noreferrer"><img src={image.thumbnail_url ? image.thumbnail_url : image.media_url} /></a>
                    </div>
                )) : ''}
            </InstagramContainer>
        </InstaFeed>
    )
}

export const HeroHomePageSection = () => {

    const HeroSection = styled('section', {
        color: 'white',
        display: 'flex',
        flexFlow: 'column wrap',
        minHeight: '100vh',
        backgroundColor: '#7e8999',
        fontFamily: '$default',
        padding: '80px 40px',
        alignItems: 'center',
        textAlign: 'center',
        '& h1': {
            fontSize: '60px',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
        '& p': {
            fontSize: '24px',
            '@bp1': {
                marginTop: '20px',
                fontSize: '22px',
                lineHeight: '1.2',
            },
        },
        '& a': {
            marginTop: '24px',
            padding: '14px 40px',
            letterSpacing: '4px',
            fontFamily: 'Arial',
            fontSize: '14px',
            textTransform: 'uppercase',
            backgroundColor: 'black',
            height: '48px',
        }
    });

    return (
        <HeroSection>
            <h1>Better Days Are Here</h1>
            <p>Gentle skincare, transformative results.</p>
            <Link to="/blah">Shop Now</Link>
        </HeroSection>
    )
};

export const TestimonialsHomePageSection = () => {

    var settings = {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        speed: 500,
        adaptiveHeight: true,
    };

    const Section = styled('section', {
        // width: '100%',
        backgroundColor: '#f8f5f1',
        textAlign: 'center',
        fontSize: '24px',
        lineHeight: '1.8',
        fontFamily: 'Benne',
        '& p': {
            display: 'flex',
            cursor: 'pointer',
            fontStyle: 'italic',
            '@bp1': {
                fontSize: '22px !important',
                lineHeight: '1.8',
            },
            '@bp2': {
                maxWidth: '640px',
            }
        },
        '& h4': {
            color: '#585d6c',
            letterSpacing: '2px',
            fontWeight: 'bold',
            '@bp1': {
                marginTop: '8px',
                fontSize: '16px !important',
            },
            '@bp2': {
                marginTop: '8px',
                fontSize: '16px !important',
            },
        },
        '& .slick-dots': {
            backgroundColor: '#f8f5f1',
            paddingBottom: '24px',
            marginBottom: '48px',
        },
        '& .testimonialContainer': {
            display: 'flex',
            flexFlow: 'column wrap',
            padding: '60px 40px 120px 40px',
            justifyContent: 'center',
            alignItems: 'center',
            '@bp1': {
                padding: '60px 40px 120px 40px',
            },
        }
    });

    return (
        <Section>
            <Slider {...settings}>
                <div>
                    <div className='testimonialContainer'>
                        <p>"I noticed a difference after about 3 days, my skin felt very cushiony and soothed which is something I haven’t felt before. I noticed that the texture was much more refined as well."</p>
                        <h4>VICTORIA</h4>
                    </div>
                </div>
                <div>
                    <div className='testimonialContainer'>
                        <p>"I am a new person now. Honestly my skin is combination and sensitive it’s sooooo hard to find something that doesn’t break me out. This is the first time my skin enjoys something!"</p>
                        <h4>JEAN</h4>
                    </div>
                </div>
                <div>
                    <div className='testimonialContainer'>
                        <p>"Been using the essence for about two weeks and I’ve noticed how it has softened and brightened up my complexion. I love how it plumps my skin instantly too!"</p>
                        <h4>LIZ</h4>
                    </div>
                </div>
                <div>
                    <div className='testimonialContainer'>
                        <p>"It makes my skin so smooth. I don’t think I need to use anything else! I usually have some bumps when I wake up in the morning but today they’re all gone! Plus, I love not having to do so many steps."</p>
                        <h4>G.J</h4>
                    </div>
                </div>
                <div>
                    <div className='testimonialContainer'>
                        <p>"In a nutshell I love it and I have eczema and super dry skin too. I had to pair it with a sleeping mask because it absorbs very fast. But I didn't use anything else. My skin was so bright the next day, no joke!"</p>
                        <h4>CLAUDETTE</h4>
                    </div>
                </div>
                <div>
                    <div className='testimonialContainer'>
                        <p>"My severe maskne situation improved drastically within a week of using this serum. I rarely finish my skincare products but I did with this little vial of magic."</p>
                        <h4>C.W</h4>
                    </div>
                </div>
            </Slider>
        </Section>
    )
};

export const IngredientLibraryHomePageSection = ({ showButton }) => {
    const data = useStaticQuery(
        graphql`
          query {
            allFile: file(name: { eq: "ingredientlibrary" }) {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1920) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `
    )

    // console.log(data);

    const imageData = data.allFile.childImageSharp.fluid;

    const Section = styled(BackgroundImage, {
        color: 'white',
        display: 'flex',
        flexFlow: 'column wrap',
        height: '100vh',
        // backgroundImage: `url(${ingredientLibrary})`,
        // backgroundSize: 'cover',
        fontFamily: '$default',
        padding: '140px 40px',
        alignItems: 'center',
        textAlign: 'center',
        '@bp1': {
            height: '700px',
            padding: '80px 40px',
            // backgroundPosition: '-180px',
        },
        '@bp2': {
            // backgroundPosition: 'center',
        },
        '& h2': {
            fontSize: '60px',
            lineHeight: '1.2',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
        '& p': {
            marginTop: '20px',
            maxWidth: '600px',
            fontFamily: '$lato',
            fontSize: '18px',
            letterSpacing: '0.5px',
            '@bp1': {
                marginTop: '20px',
                fontSize: '18px',
                letterSpacing: '0.5px',
            },
        },
        '& a': {
            marginTop: '24px',
            // padding: '14px 40px',
            letterSpacing: '4px',
            fontFamily: '$lato',
            fontSize: '14px',
            textTransform: "uppercase",
            textDecoration: 'underline',
            textUnderlineOffset: '6px',
            // textDecoration: 'underline',
            // backgroundColor: 'black',
            // height: '48px',
        }
    });

    return (
        <Section fluid={imageData}>
            {/* <BackgroundImage
                fluid={imageData}
            > */}
            <h2>Ingredient Library</h2>
            <p>From plant-based antioxidants to skin-identical elements to proven actives and Traditional Chinese Medicine extracts, our ingredients are chosen to work together for transformative results.</p>
            {showButton ? <Link to={"/pages/ingredients"}>Learn More</Link> : ''}
            {/* </BackgroundImage> */}
        </Section>
    )
};
